module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var corner = [0,2,4,6,8,10,15,20];

    ; __append("\r\n<div class=\"prop-header\"><span class=\"prop-label\">Border</span></div>\r\n<div class=\"row prop-detail\">\r\n    <div class=\"row ")
    ; __append(escapeFn(hideColor))
    ; __append("\">\r\n		<div class=\"col-md-12 subsection nopadding-r\">\r\n			<label class=\"prop-sublabel label-75\">Color</label> \r\n			<div class=\"nopadding;\">\r\n				<input type=\"color\" id=\"borderColorPicker\" name=\"borderColor\" value=\"")
    ; __append(escapeFn(borderColor))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n				<input type=\"text\" id=\"borderColor\" name=\"borderColor\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn(borderColor))
    ; __append("\" />\r\n			</div> \r\n		</div> \r\n    </div>\r\n	<div class=\"row ")
    ; __append(escapeFn(hideRadius))
    ; __append("\">\r\n		<div class=\"col-md-12 subsection nopadding-r\">\r\n			<label class=\"prop-sublabel label-75\">Corner Radius</label>\r\n			<div class=\"nopadding;\">\r\n				<select name=\"cornerRadius\" id=\"cornerRadius\">\r\n					")
    ;  for (var i = 0; i < corner.length; i++) { 
    ; __append("\r\n						<option value=\"")
    ; __append(escapeFn(corner[i]))
    ; __append("\">")
    ; __append(escapeFn(corner[i]))
    ; __append("</option>\r\n					")
    ;  }; 
    ; __append("\r\n				</select>\r\n			</div> \r\n		</div>  \r\n	</div>\r\n</div>\r\n\r\n\r\n")
  }
  return __output;

}